export default __webpack_public_path__ + "static/media/help-1.9f928b47.png";